import gql from 'graphql-tag';
import BaseContentBundleFragment from './fragments/BaseContentBundle';
import StandaloneContentBundleFragment from './fragments/StandaloneContentBundle';

export default gql`
  query fetchMoreContent(
    $site: String!
    $path: String!
    $preview: String
    $wptest: String
    $cursor: String
    $limit: Int
  ) {
    page(
      input: {
        site: $site
        path: $path
        preview: $preview
        wptest: $wptest
        cursor: $cursor
        limit: $limit
      }
    ) {
      contentBundles {
        data {
          ...BaseContentBundleFragment
          ...StandaloneContentBundleFragment
        }
        pageInfo {
          nextCursor
        }
      }
    }
  }
  ${BaseContentBundleFragment}
  ${StandaloneContentBundleFragment}
`;
